import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { api } from '@/lib/api'

export default function AnalyticsTracker() {
  const location = useLocation()

  useEffect(() => {
    api.post('/analytics/track', {
      path: location.pathname + location.search,
      referrer: document.referrer || '',
    }).catch(() => {})
  }, [location.pathname, location.search])

  return null
}
